import { createFileRoute } from '@tanstack/react-router'
import BrandingSettings from '@/pages/settings/branding'

export const Route = createFileRoute(
  '/(protected)/settings/branding'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <BrandingSettings />
}
